// extracted by mini-css-extract-plugin
export default {"wrapper":"rodoViev_wrapper__-Hpwl"};